import { Button, ButtonProps, CircularProgress } from '@mui/material';

export interface ButtonWithLoadingProps extends ButtonProps {
  isLoading?: boolean;
  loadingIconSize?: number;
}

const ButtonWithLoading = ({
  children,
  isLoading,
  loadingIconSize,
  ...rest
}: ButtonWithLoadingProps) => (
  <Button
    {...rest}
    disabled={rest.disabled || isLoading}
    startIcon={
      isLoading ? <CircularProgress color="primary" size={loadingIconSize || 20} /> : rest.startIcon
    }
  >
    {children}
  </Button>
);

export default ButtonWithLoading;
